<template>
  <el-dialog title="打印设置" :visible.sync="printDialogShow" width="520px" :close-on-click-modal="false" id='c-printDialog_ss'>
    <div class='print_container'>
      <div>
        <span class='printTitle'>打印范围：</span>
        <div style='margin-top: 20px;margin-left: 10px;'>
             <el-radio v-model="printFormData.exportScope" label="1">当前勾选</el-radio>
             <el-radio v-model="printFormData.exportScope" label="2">当前期间全部</el-radio>
        </div>

      </div>
      <div style='margin-top: 20px;'>
        <span class='printTitle'>打印内容：</span>
        <div style='margin-top: 20px;margin-left: 10px;'>
            <el-checkbox-group v-model="printFormData.checkList" >
              <el-checkbox v-for='item in PDFcustomList' :label="item.id" :disabled='item.type' :key='item.id'>{{item.name}}</el-checkbox>
            </el-checkbox-group>
        </div>
      </div>
      <div style='margin-top: 20px;text-align: right;'>
        <el-button size="small" class='minButton' @click='handlePrint'>打印</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props:{

    },
    data() {
      return {
        printDialogShow:false,
        PDFcustomList:[],
        printFormData:{
          exportScope:"2",
          checkList:[],
        }
      }
    },
    methods:{
      handlePrint() {
        this.$emit("print",this.printFormData);
      }
    }
  }
</script>

<style lang="less">
  #c-printDialog_ss {
       .el-dialog__header {
         border-bottom: 1px solid #eee;
       }
       .printTitle {
         font-weight: bold;
         color: #666;
       }
       .el-checkbox {
         margin-bottom: 10px;
       }

     }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/c-print.vue